import { mergeStyleSets } from '@uifabric/merge-styles';
import theme, { layout } from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    fontSize: pxToRem(28),
    fontWeight: 600,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: '1 !important',
    letterSpacing: -0.2,
    textAlign: 'left',
    color: theme.palette.neutralDark,
    margin: `0 auto ${pxToRem(46)}`,
    width: '100%',
    padding: '2rem 1rem 0',
    wordBreak: 'break-all',
    selectors: {
      [layout.breakpoints.min.md]: {
        paddingTop: '3rem',
      },
      [layout.breakpoints.min.lg]: {
        maxWidth: `calc(${pxToRem(910)} + 4rem)`,
        paddingLeft: '2rem',
        paddingRight: '2rem',
      },
      [layout.breakpoints.min.xxl]: {
        maxWidth: `calc(${pxToRem(1074)} + 4rem)`,
      },
    },
  },
  fullWidth: {
    selectors: {
      [layout.breakpoints.min.lg]: {
        maxWidth: '100%',
      },
    },
  },
});
